<template>
  <div class="row-flex width-100">
    <div
      v-if="!vehicle.id"
      class="item flex-center-content pointer p-relative"
      @click="$emit('onAdd')"
      v-ripple
    >
      <v-icon class="mr-2" color="#9FAEB8">mdi-plus</v-icon>
      <span class="size-16 font-weight-bold color-grey">Füge ein Auto hinzu</span>
    </div>
    <div v-else class="item flex-center-content pointer p-relative bg0">
      <img class="contain-center" :src="require(`@/assets/img/vehicles/${vehicle.image}`)" />
      <v-btn @click="$emit('onRemove', vehicle)" class="mx-2 remove-btn" fab dark color="white" x-small>
        <v-icon color="black" dark>mdi-close</v-icon>
      </v-btn>
      <div class="vehicle-meta col-flex size-18 white--text">
        <span class="weight6">{{vehicle.name}}</span>
        <span>{{vehicle.model}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vehicle-header',
  props: ['vehicle']
}
</script>

<style lang="scss" scoped>
.row-flex {
  flex-grow: 1;
}
.item {
  flex-grow: 1;
  background-color: #E2E7EA;

  .remove-btn {
    position: absolute;
    top: 10px;
    right: 5px;
  }
}
.vehicle-meta {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.51);
  width: 100%;
  padding: 5px 15px;
  bottom: 0;
}
.meta-right .vehicle-meta {
  text-align: right;
}
</style>